// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamSpinner__root--2xtse"};